import { AdaAction } from '../actions'
import { applySystemEdit } from '../utils/applySystemEdit'
import type { SystemEditOperation } from '../utils/systemEditSchema'

interface SystemEditArgs {
  operations: SystemEditOperation[]
}

export async function handleSystemEdit(action: AdaAction) {
  const args = action.args as SystemEditArgs

  if (!args.operations || !Array.isArray(args.operations) || args.operations.length === 0) {
    throw new Error('System edit requires at least one operation')
  }

  await applySystemEdit(args.operations)
}
